import { Outage } from '@/apis/outages/types/outagesApi';
import {
  Label,
  Stack,
  TextTruncate,
  Typography,
  useWindowSize,
} from '@data-products-and-ai/react-components';
import { FC } from 'react';
import { SemiCircleProgressBar } from '@/components';
import { getRiskColor, getRiskLabel } from '@/utils';
import { generatePath, useLocation, useNavigate } from 'react-router';
import { OUTAGE_ROUTE } from '@/pages/Outages/routes';
import { RiskWarning } from '@/pages/Outages/components';
import { MOBILE_WIDTH } from '@/constants';

import '@/pages/Outages/components/OutageCard/OutageCard.scss';

interface OutageCardProps {
  outage: Outage;
}

export const OutageCard: FC<OutageCardProps> = ({ outage }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { width } = useWindowSize();

  const handleClick = () => {
    navigate(
      generatePath(OUTAGE_ROUTE, { outageId: outage.outageId.toString() }),
      { state: { from: `${location.pathname}${location.search}` } },
    );
  };

  return (
    <div className="outage-card" onClick={handleClick}>
      <div className="outage-card__item">
        <Label tag="textextrasmall_strong">Outage ID</Label>
        <Typography color="var(--color-default)" tag="textdefault">
          {outage.outageId}
        </Typography>
      </div>
      <div className="outage-card__item">
        <Label tag="textextrasmall_strong">Site Name</Label>
        <Typography color="var(--color-default)" tag="textdefault">
          {outage.siteId}
        </Typography>
      </div>
      <div className="outage-card__item outage-card__item--single-line">
        <Label tag="textextrasmall_strong">Outage Name</Label>
        <Typography color="var(--color-default)" tag="textdefault">
          <TextTruncate showMoreText showLessText width="100" lines={3}>
            {outage.outageName}
          </TextTruncate>
        </Typography>
      </div>
      <div className="outage-card__item outage-card__item--single-line outage-card__item--risk-value">
        <Stack gap={24}>
          <SemiCircleProgressBar
            progress={outage.outagePercentile}
            size={width > MOBILE_WIDTH ? 200 : 150}
            strokeWidth={12}
            color={getRiskColor(outage.outagePercentile)}
            labelText={getRiskLabel(outage.outagePercentile)}
            mode="label"
            showLabel
          />
          <RiskWarning
            highRiskCount={outage.highRiskCount ?? 0}
            midRiskCount={outage.midRiskCount ?? 0}
          />
        </Stack>
      </div>
    </div>
  );
};
